import tzlookup from '@photostructure/tz-lookup'

export function getTimezoneFromCoordinates(lat: number, lon: number): string | null {
  try {
    return tzlookup(lat, lon)
  } catch (error) {
    console.error('Failed to lookup timezone', error)
    return null
  }
}

export function getBrowserTimezones(): string[] {
  if ('supportedValuesOf' in Intl) {
    return (Intl as any).supportedValuesOf('timeZone')
  }
  return [Intl.DateTimeFormat().resolvedOptions().timeZone]
}
